module.exports = __webpack_public_path__ + "static/img/honor27.f2e941d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor27.png
// module id = OevZ
// module chunks = 0